import { availabilityGallery } from './data';
import anime from 'animejs';

let thumbs = [];
let selectedInteriorIndex = 0;
let params;
let autoPlayInteriorInstance;
let canAutoplayInterior = true;

//GALLERY STUFF GOES HERE -------------------------------------------------------------------

export function CleanInteriorGallery() {
	// canAutoplay = false;
	if (autoPlayInteriorInstance) clearInterval(autoPlayInteriorInstance);
	thumbs = [];
	selectedInteriorIndex = 0;
}

export function InitInteriorGallery(_params) {
	params = _params;
	availabilityGallery.map((l, i) => {
		const d = document.createElement('div');
		d.classList.add('thumb');
		d.onclick = () => {
			JumpToSlide(i);
		};
		params.galleryThumbCont.appendChild(d);
		thumbs.push(d);
	});
	JumpToSlide(selectedInteriorIndex, true);
	canAutoplayInterior = true;
	autoPlayInteriorInstance = setInterval(Autoplay, 5000);
}

export function JumpToSlide(i, keepAutoPlay = null) {
	if (keepAutoPlay) {
		canAutoplayInterior = true;
	} else {
		canAutoplayInterior = false;
	}
	//select thumb
	thumbs.map((t) => t.classList.remove('thumb-active'));
	thumbs[i].classList.add('thumb-active');
	params.galleryTitle.innerHTML = availabilityGallery[i].label;

	selectedInteriorIndex = i;

	anime({
		targets: params.galleryImage,
		opacity: [ 1, 0 ],
		duration: 400,
		easing: 'easeInOutQuad',
		complete: () => {
			params.galleryImage.style.backgroundImage = `url(images/availabilityGallery/${availabilityGallery[i].img})`;
			anime({
				targets: params.galleryImage,
				opacity: [ 0, 1 ],
				duration: 400,
				easing: 'easeInOutQuad'
			});
		}
	});
}

export function NavigateInteriorSlide(_dir, keepAutoPlay = null) {
	let dir = 0;
	if (_dir === 'next') {
		dir = +1;
	} else if (_dir === 'prev') {
		dir = -1;
	}

	let newIndex = selectedInteriorIndex + dir;

	if (newIndex > availabilityGallery.length - 1) {
		newIndex = 0;
	} else if (newIndex < 0) {
		newIndex = availabilityGallery.length - 1;
	}

	JumpToSlide(newIndex, keepAutoPlay);
}

function Autoplay() {
	if (canAutoplayInterior) {
		NavigateInteriorSlide('next', true);
	}
}



// WEBPACK FOOTER //
// ./src/interiorGallery.js